import React from 'react';
import {IntegrationApiOptionsField} from '../IntegrationApiOptionsField';
import {IntegrationApiOptionsFieldV2} from "../IntegrationApiOptionsFieldV2";

interface Props {
    readonly onChange: (name: string, value: any) => void,
    readonly data: any
}

export function IntegrationApiParams({onChange,data}: Props) {
    return (
        <div>
            {/*<IntegrationApiOptionsField data={data.params} onChange={(value) => onChange("params", value)}/>*/}
            <IntegrationApiOptionsFieldV2 data={data.params} onChange={(value) => onChange("params", value)}/>
        </div>
    );
}




